import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { CnaePermitidoPesquisaComponent } from "./pesquisa/cnae-permitido-pesquisa.component";
import { NovoCnaePermitidoComponent } from "./pesquisa/novo/novo-cnae-permitido.component";

const routes: Routes = [
  {
    path: 'cnaes-permitidos',
    component: CnaePermitidoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
  {
    path: 'cnaes-permitidos/cadastro/:id',
    component: NovoCnaePermitidoComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
];

@NgModule({
  imports:[RouterModule.forChild(routes)],
  exports:[RouterModule]
})
export class CnaePermitidoRoutingModule { }